import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NameValue } from '../../models/name-value';
import { LOADED_STATUSES } from '../../constants/loaded-statuses';

@Component({
    selector: 'app-loaded-empty-filter',
    templateUrl: './loaded-empty-filter.component.html',
    styleUrls: ['./loaded-empty-filter.component.scss'],
    imports: [LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LoadedEmptyFilterComponent),
            multi: true,
        },
    ],
})
export class LoadedEmptyFilterComponent implements ControlValueAccessor {
    private cdr = inject(ChangeDetectorRef);

    public readonly loadedStatuses: NameValue[] = LOADED_STATUSES;

    public isDisabled: boolean = false;
    public value: string[] = [];

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[]): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }
}
